import React, { useState, useEffect } from "react";
import "./style.css";
// import BannerImg1 from "../../../assets/img/banner/b2.png";
// import BannerImg2 from "../../../assets/img/banner/banner.png";
// import BannerImg3 from "../../../assets/img/banner/banner-bg.png";
// import BannerImg4 from "../../../assets/img/banner/donat_banner.jpg";

import { Link } from "react-router-dom";

import BannerImg1 from "../../../assets/img/banner/WhatsApp Image 2026-03-02 at 2.52.46 PM (1).jpeg";
import BannerImg2 from "../../../assets/img/banner/WhatsApp Image 2026-03-02 at 2.52.46 PM (2).jpeg";
import BannerImg3 from "../../../assets/img/banner/WhatsApp Image 2026-03-02 at 2.52.46 PM (3).jpeg";
import BannerImg4 from "../../../assets/img/banner/WhatsApp Image 2026-03-02 at 2.52.46 PM.jpeg";
import BannerImg5 from "../../../assets/img/banner/WhatsApp Image 2026-03-02 at 2.52.46 PM (1).jpeg";
import BannerImg6 from "../../../assets/img/banner/WhatsApp Image 2026-03-02 at 2.52.46 PM (2).jpeg";
import BannerImg7 from "../../../assets/img/banner/WhatsApp Image 2026-03-02 at 2.52.46 PM (3).jpeg";
import BannerImg8 from "../../../assets/img/banner/WhatsApp Image 2026-03-02 at 2.52.46 PM.jpeg";

const images = [
  BannerImg1,
  BannerImg2,
  BannerImg3,
  BannerImg4,
  BannerImg5,
  BannerImg6,
  BannerImg7,
  BannerImg8,
];

const HomeBanner = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section id="home_one_banner" className="banner-container">
      <div className="container">
        <div className="banner-center-row">
          <div className="banner-img-side left">
            <img
              src={
                images[(currentImageIndex + images.length - 1) % images.length]
              }
              alt="img-left"
              className="banner-img book-img"
            />
          </div>
          <div className="banner_one_text banner-center-text">
            <h1>
              <span>
                <span className="color_big">Cradle Care </span> Foundation
              </span>
            </h1>
            <p>
              Embracing vulnerable moms to be with love, reassurance and
              practical support
              <br />
            </p>
            {/* <p>
                            Many pregnant women—especially vulnerable young adults and single mothers—face
                            overwhelming emotions and difficult choices. Social stigma, financial hardship, and emotional
                            distress can lead to thoughts of abortion or abandonment of their babies.
                            <br />
                            <strong>But no mother should have to walk this path alone</strong>
                        </p> */}
            <div className="banner-support-btn">
              <a
                href="/support"
                className="btn btn_md btn_theme"
                target="_blank"
                rel="noopener noreferrer"
              >
                Get Support
              </a>
            </div>
          </div>
          <div className="banner-img-side right">
            <img
              src={BannerImg5}
              alt="img-right"
              className="banner-img book-img"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeBanner;
